import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  "fill-rule": "evenodd",
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 120 120"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "stroke-width": "2"
    }, [
      _createElementVNode("path", { d: "M.93.93h117.235v117.235H.929z" }),
      _createElementVNode("path", {
        "stroke-linejoin": "miter",
        d: "m59.475 1.246.05 116.509"
      })
    ], -1),
    _createElementVNode("path", {
      fill: "none",
      "stroke-linejoin": "miter",
      "stroke-width": "2",
      d: "m1.246 59.525 116.509-.05"
    }, null, -1)
  ])))
}
export default { render: render }